import { render, staticRenderFns } from "./BranchSwitcher.vue?vue&type=template&id=7d1721aa&scoped=true"
import script from "./BranchSwitcher.vue?vue&type=script&lang=js"
export * from "./BranchSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BranchSwitcher.vue?vue&type=style&index=0&id=7d1721aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1721aa",
  null
  
)

export default component.exports